import { Pipe, PipeTransform } from '@angular/core';

import { Classificacao } from '../classificacao';

@Pipe({
    name: 'classificacaoNivelTipoClassificacaoFilter',
    pure: false
})
export class ClassificacaoNivelTipoClassificacaoFilterPipe implements PipeTransform {
    /** Filtra as classificações pelo nível do seu tipo de classificação */
    transform(entities: Classificacao[], nivel: number = null): Classificacao[] {
        if (!entities) {
            return [];
        }
        // Retorna todas as classificações quando não for informado um nível para filtar
        if (!nivel) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.nivelTipoClassificacao === nivel);
    }
}
